<template>
  <v-container>
    <v-card class="mx-auto" flat>
      <v-toolbar color="grey" dark dense>
        <v-toolbar-title class="d-none d-sm-flex"><b>Cuatrimestres por Periodo</b></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="600px" persistent>
          <template v-slot:activator="{ on }">
            <v-btn color="grey darken-2" dark class="mb-2" v-on="on">Nuevo</v-btn>
          </template>
          <v-card v-if="dialog">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="editedItem.periodo_id"
                        :items="listPeriodos"
                        item-text="nombre"
                        item-value="id"
                        label="Periodo"
                        :rules="[rules.required]"
                        dense
                        :disabled="editedIndex > -1"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="editedItem.cuatrimestre_id"
                        :items="listCuatrimestres"
                        item-text="titulo"
                        item-value="id"
                        label="Cuatrimestre"
                        :rules="[rules.required]"
                        dense
                        :disabled="editedIndex > -1"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-menu
                        v-model="menuFechaInicial"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.fecha_inicial"
                            label="Fecha Inicial"
                            :rules="[rules.required]"
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            prepend-inner-icon="mdi-calendar"
                          />
                        </template>
                        <v-date-picker
                          v-model="editedItem.fecha_inicial"
                          @input="menuFechaInicial = false"
                          locale="es"
                          color="primary"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-menu
                        v-model="menuFechaFinal"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.fecha_final"
                            label="Fecha Final"
                            :rules="[rules.required]"
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            prepend-inner-icon="mdi-calendar"
                          />
                        </template>
                        <v-date-picker
                          v-model="editedItem.fecha_final"
                          @input="menuFechaFinal = false"
                          locale="es"
                          color="primary"
                          :min="editedItem.fecha_inicial"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" dark @click="close">Cancelar</v-btn>
              <v-btn v-if="editedIndex > -1" class="white--text" color="yellow darken-2" @click="editRegistro" :disabled="!valid" :loading="loading">Guardar</v-btn>
              <v-btn v-else class="white--text" color="yellow darken-2" @click="addRegistro" :disabled="!valid" :loading="loading">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <br>
      <v-row class="px-4">
        <v-col cols="12" md="4">
          <v-select
            :items="listPeriodos"
            v-model="filtro_periodo"
            item-text="nombre"
            item-value="id"
            label="Filtrar por Periodo"
            dense
            outlined
            clearable
            @change="onFilterChange"
          />
        </v-col>
      </v-row>
      <v-data-table
        dense
        :headers="headers"
        :items="listRegistros"
        class="elevation-1"
        :loading="loading"
        hide-default-footer
        :items-per-page="itemsPerPage"
        no-data-text="No se encontraron registros"
      >
        <template v-slot:item.periodo="{ item }">
          {{ item.periodo ? item.periodo.nombre : '-' }}
        </template>
        <template v-slot:item.cuatrimestre="{ item }">
          {{ item.cuatrimestre ? item.cuatrimestre.titulo : '-' }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon color="orange" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <!-- <v-icon color="red" @click="deleteRegistro(item)">mdi-close</v-icon> -->
        </template>
      </v-data-table>
      <div class="text-center pt-2" v-if="pagination.total > 1">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="7"
          @input="onPageChange"
        />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
const Swal = require('sweetalert2');
export default {
  data: () => ({
    loading: false,
    dialog: false,
    valid: true,
    menuFechaInicial: false,
    menuFechaFinal: false,
    pagination: { current: 1, total: 0 },
    itemsPerPage: 20,
    filtro_periodo: null,
    headers: [
      { text: 'Periodo', value: 'periodo', sortable: false },
      { text: 'Cuatrimestre', value: 'cuatrimestre', sortable: false },
      { text: 'Fecha Inicial', value: 'fecha_inicial', sortable: false },
      { text: 'Fecha Final', value: 'fecha_final', sortable: false },
      { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '12%' }
    ],
    listRegistros: [],
    listCuatrimestres: [],
    editedIndex: -1,
    editedItem: {
      periodo_id: '',
      cuatrimestre_id: '',
      fecha_inicial: '',
      fecha_final: '',
    },
    defaultItem: {
      periodo_id: '',
      cuatrimestre_id: '',
      fecha_inicial: '',
      fecha_final: '',
    },
    rules: {
      required: v => !!v || 'Este campo es requerido',
    },
  }),
  computed: {
    ...mapGetters(["listPeriodos"]),
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Cuatrimestre' : 'Editar Cuatrimestre';
    },
  },
  mounted() {
    this.getPeriodos();
    this.getCuatrimestres();
    this.getRegistros();
  },
  methods: {
    getPeriodos() {
      this.$store.dispatch("GET_PERIODOS", { url: "periodos" });
    },
    getCuatrimestres() {
      this.$store.dispatch("GET_SOLICITUDES", { url: "/periodo/1/cuatrimestres" }).then(response => {
        // Los cuatrimestres son siempre los mismos 3, tomamos de cualquier periodo
        // Alternativa: hardcodear
        this.listCuatrimestres = [
          { id: 1, titulo: '1er Cuatrimestre' },
          { id: 2, titulo: '2do Cuatrimestre' },
          { id: 3, titulo: '3er Cuatrimestre' },
        ];
      }).catch(() => {
        this.listCuatrimestres = [
          { id: 1, titulo: '1er Cuatrimestre' },
          { id: 2, titulo: '2do Cuatrimestre' },
          { id: 3, titulo: '3er Cuatrimestre' },
        ];
      });
    },
    getRegistros() {
      this.loading = true;
      let url = '/periodo-cuatrimestres?page=' + this.pagination.current;
      if (this.filtro_periodo) {
        url += '&periodo_id=' + this.filtro_periodo;
      }
      this.$store.dispatch("GET_SOLICITUDES", { url: url }).then(response => {
        const data = response.data.data.periodo_cuatrimestres;
        this.listRegistros = data.data;
        this.pagination.current = data.current_page;
        this.pagination.total = data.last_page;
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.loading = false;
      });
    },
    onPageChange() {
      this.getRegistros();
    },
    onFilterChange() {
      this.pagination.current = 1;
      this.getRegistros();
    },
    editItem(item) {
      this.editedIndex = 1;
      this.editedItem = {
        id: item.id,
        periodo_id: item.periodo_id,
        cuatrimestre_id: item.cuatrimestre_id,
        fecha_inicial: item.fecha_inicial,
        fecha_final: item.fecha_final,
      };
      this.dialog = true;
    },
    addRegistro() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.$store.dispatch("SAVE_PERITO", { url: "/periodo-cuatrimestre", data: this.editedItem }).then(() => {
        this.close();
        Swal.fire({ icon: 'success', title: 'Cuatrimestre agregado correctamente', confirmButtonText: 'Aceptar' });
        this.getRegistros();
      }).catch(error => {
        this.loading = false;
        const msg = error.response && error.response.data ? (error.response.data.message || error.response.data.errors) : 'Error al crear';
        Swal.fire({ icon: 'error', title: 'Error', text: Array.isArray(msg) ? msg.join('. ') : msg, confirmButtonText: 'Aceptar' });
      });
    },
    editRegistro() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.$store.dispatch("ACTIVAR_PERITO", {
        url: "/periodo-cuatrimestre/" + this.editedItem.id,
        data: {
          fecha_inicial: this.editedItem.fecha_inicial,
          fecha_final: this.editedItem.fecha_final,
        }
      }).then(() => {
        this.close();
        Swal.fire({ icon: 'success', title: 'Cuatrimestre actualizado correctamente', confirmButtonText: 'Aceptar' });
        this.getRegistros();
      }).catch(error => {
        this.loading = false;
        const msg = error.response && error.response.data ? (error.response.data.message || error.response.data.errors) : 'Error al actualizar';
        Swal.fire({ icon: 'error', title: 'Error', text: Array.isArray(msg) ? msg.join('. ') : msg, confirmButtonText: 'Aceptar' });
      });
    },
    deleteRegistro(item) {
      const nombre = (item.periodo ? item.periodo.nombre : '') + ' - ' + (item.cuatrimestre ? item.cuatrimestre.titulo : '');
      this.$swal({
        title: '¿Desea eliminar "' + nombre + '"?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_PERITO", { url: "/periodo-cuatrimestre/" + item.id }).then(() => {
            Swal.fire({ icon: 'success', title: 'Eliminado correctamente', confirmButtonText: 'Aceptar' });
            this.getRegistros();
          }).catch(err => {
            console.log(err);
          });
        }
      });
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.menuFechaInicial = false;
      this.menuFechaFinal = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
  },
};
</script>
